import { connect } from 'react-redux';
import { actionGetMarketList } from 'store/market/actions';
import {
  actionGetInternalAccountList,
  actionDeleteInternalAccount,
} from 'store/manageAccount/actions';

import ManagerInternalAccount from './ManagerInternalAccount';

const mapStateToProps = (state) => ({
  marketList: state.Market.marketList,
  marketTotal: state.Market.marketTotal,
  isLoadingMarketList: state.Market.isLoadingMarketList,

  internalAccountList: state.ManageAccount.internalAccountList,
  internalAccountTotal: state.ManageAccount.internalAccountTotal,
  isLoadingGetInternalAccountList: state.ManageAccount.isLoadingGetInternalAccountList,
  isLoadingDeleteInternalAccount: state.ManageAccount.isLoadingDeleteInternalAccount,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMarketList: (payload) => dispatch(actionGetMarketList(payload)),
  actionGetInternalAccountList: (payload) => dispatch(actionGetInternalAccountList(payload)),
  actionDeleteInternalAccount: (payload) => dispatch(actionDeleteInternalAccount(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerInternalAccount);
